module.exports = "<div id=\"blog\" class=\"panel content\">\n    <h1 class=\"d-inline-block\">Au Courant</h1>\n    <a routerLink=\"/blog\" class=\"d-inline-block float-right\">\n        <i class=\"fa fa-level-up fa-2x\" aria-hidden=\"true\" *ngIf=\"showingTopic\"></i></a>\n    <hr/>\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/blog.component.html
// module id = ./src/app/blog/blog.component.html
// module chunks = main